import { Container, Spinner } from 'react-bootstrap';
const LoadingFullScreen: React.FC = () => {

  return (
    <Container 
      fluid 
      className="d-flex flex-column justify-content-center align-items-center" 
      style={{ 
        height: '100vh',
      }}
    >
      <div className="text-center">
        <img 
          src="/images/logo.svg" 
          alt="MultyHealth Logo" 
          style={{ 
            maxWidth: '400px',
            width: '400px',
            marginBottom: '2rem',
            animation: 'pulse 2s infinite'
          }} 
        />
        <div>
          <Spinner 
            animation="border" 
            variant="primary" 
            style={{ 
              width: '3rem', 
              height: '3rem' 
            }} 
          />
        </div>
      </div>

      <style>
        {`
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
      </style>
    </Container>
  );
};

export default LoadingFullScreen;
